import { StyleSheet } from "@react-pdf/renderer";

export const COLORS = {
  text: "#424242",
  textMuted: "#616161",
  border: "#D0D0D0",
  bg: "#FFFFFF",
  bgSection: "#FAFAFA",
};

export const styles = StyleSheet.create({
  // ─── Page ───────────────────────────────────────────────────────────────────
  page: {
    backgroundColor: COLORS.bg,
    fontFamily: "Inter",
    paddingTop: 120,
    paddingBottom: 93,
    paddingHorizontal: 16,
  },

  // ─── Fixed Header wrapper ────────────────────────────────────────────────────
  pageHeader: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 36,
    paddingTop: 15,
    backgroundColor: COLORS.bg,
  },

  // ─── Fixed Footer wrapper ────────────────────────────────────────────────────
  pageFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    paddingHorizontal: 36,
    paddingBottom: 30,
    paddingTop: 18,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: COLORS.bg,
  },

  // ─── Typography ──────────────────────────────────────────────────────────────

  // 1. Form Title (Intervention Communication Form)
  formTitle: {
    fontSize: 14,
    fontWeight: 700,
    color: COLORS.text,
    lineHeight: 1.1,
  },

  // 2. Form Subtitle
  formSubtitle: {
    fontSize: 10.5,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 3. Pharmacy Name in bordered box
  pharmacyNameBox: {
    fontSize: 9,
    fontWeight: 600,
    color: COLORS.textMuted,
    lineHeight: 1.2,
    textAlign: "center",
  },

  // 4. Pharmacy detail label (e.g. "Phone Number ")
  pharmacyDetailLabel: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 5. Pharmacy detail value
  pharmacyDetailValue: {
    fontSize: 9,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 6. Service Date (right-aligned)
  serviceDate: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.2,
    textAlign: "right",
  },

  // 7. Section H2 Heading
  sectionHeading: {
    fontSize: 10.5,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.3,
  },

  // 8. Sub-section Heading
  subSectionHeading: {
    fontSize: 10.5,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 9. Field Label (e.g. "Name of Service  ")
  fieldLabel: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 10. Field Value (bold answer)
  fieldValue: {
    fontSize: 9,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 11. Inline Label Part (within a mixed-weight sentence)
  inlineLabelPart: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 12. Inline Regular
  inlineRegular: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 13. Inline Bold
  inlineBold: {
    fontSize: 9,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 14. Body text
  bodyText: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 15. Fallback / empty placeholder text
  fallbackText: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.textMuted,
    lineHeight: 1.4,
  },

  // 16. Rx large
  rxLarge: {
    fontSize: 27,
    fontWeight: 700,
    color: COLORS.text,
    lineHeight: 1,
  },

  // 17. Signature line label
  signatureLabel: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 18. Pharmacist info label
  pharmacistInfoLabel: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 19. Pharmacist info value
  pharmacistInfoValue: {
    fontSize: 9,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 20. Page number
  pageNumber: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.textMuted,
    lineHeight: 1.4,
  },

  // 21. PIN note
  pinNote: {
    fontSize: 8,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.4,
  },

  // 22. Compact row label (patient row on pages 2+)
  compactLabel: {
    fontSize: 9,
    fontWeight: 400,
    color: COLORS.text,
    lineHeight: 1.2,
  },

  // 23. Compact row value
  compactValue: {
    fontSize: 9,
    fontWeight: 600,
    color: COLORS.text,
    lineHeight: 1.2,
  },
});
